import { useForm as useInertiaForm } from '@inertiajs/inertia-vue3';
import route from '@/types/Route';
export default function useBulkPurchaseForm(bulkPurchase, initialFormData, postUrlName = null) {
    const form = useInertiaForm({ ...initialFormData });
    if (bulkPurchase.value) {
        Object.keys(initialFormData).forEach((key) => {
            const typedKey = key;
            if (bulkPurchase.value && bulkPurchase.value[typedKey] !== undefined) {
                if (typedKey !== 'selected_examinations' && typedKey !== 'id') {
                    form[typedKey] = bulkPurchase.value[typedKey];
                }
            }
        });
        if (bulkPurchase.value.examinations && Array.isArray(bulkPurchase.value.examinations)) {
            form.selected_examinations = bulkPurchase.value.examinations.map((exam) => exam.id);
        }
    }
    const onFormSubmit = () => {
        if (postUrlName === null || !bulkPurchase.value?.id) {
            return;
        }
        form.put(route(postUrlName, { bulkPurchaseId: bulkPurchase.value.id }));
    };
    return {
        form,
        onFormSubmit,
    };
}
